import React from "react";
import { cn } from "@/libs/utils";
import { StudioMainLink } from "@/v2-components/pages/software/components/studio/studio-main-link";
import { useTrans } from "@/utils/useTrans";

const useStudioMainData = () => {
  const { t } = useTrans(["software"]);
  return {
    name: t("bHaptics Studio"),
    summary: [
      {
        head: t("Key Features"),
        list: [
          t("Create audio-optimized haptic profiles"),
          t("Upload and share Audio-to-Haptic profiles"),
        ],
      },
    ],
  };
};

export const StudioMainInfo = () => {
  const data = useStudioMainData();
  if (!data) {
    return;
  }

  return (
    <article className="flex h-full items-center justify-center px-4 py-6 md:p-16">
      <div className="flex h-full w-full flex-col justify-between gap-4 font-400 text-coolgray-90 md:gap-9">
        <div>
          <div className="align-center flex gap-2 pb-4 md:pb-9">
            <h1 className="text-3xl md:text-4xl">{data.name}</h1>
          </div>

          <div className="flex flex-col gap-7 md:gap-4">
            {data.summary?.map((section: any, index: number) => (
              <div key={index}>
                <h2 className="mb-4 text-xl font-500">{section.head}</h2>
                <ul className="ml-3 list-outside list-disc pl-3 text-base">
                  {section.list.map((item: string, itemIndex: number) => (
                    <li key={itemIndex}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div
          className={cn(`flex justify-center pt-4 md:justify-start md:pt-0`)}
        >
          <div className="flex w-full md:w-fit">
            <StudioMainLink />
          </div>
        </div>
      </div>
    </article>
  );
};
